import LegalLayout, { Section, List } from "@/pages/legal/LegalLayout";

export default function Terms() {
    return (
        <LegalLayout
            eyebrow="Terms & Conditions"
            title="The rules of using HomeIQ."
            lede="Using HomeIQ means you agree to the terms below. We've kept them short and specific to what this product actually does — affordability, loan, market, investment and Vastu intelligence for home buyers in India."
            lastUpdated="1 July 2026"
        >
            <Section title="What HomeIQ is">
                <p>
                    HomeIQ is an AI-assisted intelligence platform for home buyers. It combines a set of proprietary calculation engines (affordability, loan amortisation, market comparison, investment projection, composite score) with an AI-powered Vastu Analyzer and a curated PDF report generator. Everything HomeIQ shows you is <strong>advisory</strong> — it is designed to inform your decision, not to replace professional financial, legal or architectural advice.
                </p>
            </Section>

            <Section title="Acceptable use">
                <p>You may use HomeIQ for your own personal home-buying research. You may not:</p>
                <List
                    items={[
                        "Scrape, republish or resell HomeIQ's calculations, market data or reports without written permission.",
                        "Attempt to reverse-engineer, probe or interfere with the underlying calculation engines or AI infrastructure.",
                        "Upload files that are not floor plans (in particular, files that infringe copyright or contain unlawful content).",
                        "Use HomeIQ to make representations to any lender, regulator, court or third party as if the numbers were an official appraisal.",
                    ]}
                />
            </Section>

            <Section title="Your responsibilities">
                <List
                    items={[
                        "The inputs you enter (rent, salary, obligations, down-payment) drive every calculation. Please enter honest, accurate values.",
                        "The floor plan you upload must be one you have the right to share — a plan you own, or one shared with you by a builder or architect for personal review.",
                        "The name and email you provide when generating a report are yours; do not enter someone else's contact details.",
                    ]}
                />
            </Section>

            <Section title="How AI is used in the product">
                <p>
                    HomeIQ uses AI in one place: the <strong>Vastu Analyzer</strong>. When you upload a floor plan, we send a normalised image of that plan to Anthropic's Claude model to identify the direction of key rooms. The extracted information is then scored by a rule-based engine we maintain in-house.
                </p>
                <p>
                    Every other number on the site — affordability, EMI, budget, growth score, buy-vs-rent, HomeIQ score — is produced by our own deterministic engines. There is no AI in the affordability, loan, market, investment or composite score outputs.
                </p>
            </Section>

            <Section title="Financial, investment, legal & architectural advice">
                <p>
                    <strong>HomeIQ is not a bank, broker, financial advisor, lawyer or Vastu practitioner.</strong> Every read the product produces is an estimate based on the inputs you provide and public methodology. Before you commit to a property, a loan, or any transaction, you should:
                </p>
                <List
                    items={[
                        "Confirm affordability and EMI against a formal sanction letter from a licensed lender.",
                        "Have a lawyer review the sale agreement, title deed and RERA registration.",
                        "Physically visit each shortlisted property at multiple times of day.",
                        "If Vastu matters to you personally, consult a qualified practitioner in addition to our advisory read.",
                    ]}
                />
            </Section>

            <Section title="Intellectual property">
                <p>
                    The HomeIQ brand, calculation engines, market dataset, visual design, PDF report layout and this site's content are the intellectual property of HomeIQ. Your inputs and any reports generated for you remain yours to use in your personal decision-making.
                </p>
            </Section>

            <Section title="Limitation of liability">
                <p>
                    HomeIQ is provided on an "as is" basis. To the maximum extent permitted by law, we are not liable for financial losses, missed opportunities, disputes with builders or lenders, or any other damages arising from decisions you make based on the product's advisory outputs. Your reliance on HomeIQ is at your own discretion.
                </p>
            </Section>

            <Section title="Changes to these terms">
                <p>
                    We may update these terms as the product evolves. When we do, we'll change the "Last updated" date at the bottom of this page. Continued use of HomeIQ after an update means you accept the revised terms.
                </p>
            </Section>

            <Section title="Contact">
                <p>
                    Questions about these terms? Reach us on WhatsApp at <a href="https://wa.me/917406054477" target="_blank" rel="noopener noreferrer" className="text-[#1E6BFF] font-semibold hover:underline">+91 74060 54477</a>.
                </p>
            </Section>
        </LegalLayout>
    );
}
